
import React from "react";

import "./Profile.css";
import CircleImageUpload from "../components/CircleImageUpload";
import ContactDetails from "../components/ContactDetails";
import PersonalDetails from "../components/PersonalDetails";
import Dependents from "../components/Dependents";
import CurrentEmployment from "../components/CurrentEmployment";
import AwardsAndAccolades from "../components/AwardsAndAccolades";
import Skills from "../components/Skills";
import WorkExperience from "../components/WorkExperience";
import EducationDetails from "../components/EducationDetails";
import JobPosting from "../components/JobPosting";
import AboutOverview from "../components/AboutOverview";
import KeyContacts from "../components/KeyContacts";
import ProfileReadiness from "../components/ProfileReadiness";
import UploadDocument from "../components/UploadDocument";
import TransactionTimeline from "../components/TransactionTimeline";
import Task from "../components/Task";
import GenerateLoi from "../components/GenerateLoi";
import Query from "../components/Query";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faDownload, faUpload, faComment, faList, faClock, faStopwatch, faPen, faCheckSquare, faHeartbeat, } from "@fortawesome/free-solid-svg-icons";


const Profile = () => {

    return (
        <div className="container mt-6">
            <div className="profile-sec position-relative">
                <img className="w-100" src="./banner.webp" alt="Banner" />
                <div className="profile-row pb-3">
                    <div className="row align-items-end">
                        <div className="col-lg-4">
                            <div className="d-inline-block ml-20">
                                <CircleImageUpload />
                            </div>
                            <button className="btn btn-warning btn-sm ml-20">Verification Pending</button>
                            <div className="d-block ml-20 mt-3">
                                <h5>Naresh Audukoori</h5>
                                <ul>
                                    <li><FontAwesomeIcon icon={faEnvelope} className="text-primary mr-10" />
                                        naresh@gmail.com
                                    </li>
                                    <li><FontAwesomeIcon icon={faPhone} className="text-primary mr-10" />
                                        +91 000 000 0000
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="d-block text-end mr-10">
                                <button className="btn btn-primary btn-sm mr-5"><FontAwesomeIcon icon={faComment} /></button>
                                <button className="btn btn-primary btn-sm mr-5"><FontAwesomeIcon icon={faUpload} /></button>
                                <button className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faDownload} /> Download Profile</button>
                            </div>
                            <div className="d-block mr-10 mt-4 float-end">
                                <div className="d-flex gap-10">
                                    <div className="text-center border-right pe-2">
                                        <FontAwesomeIcon icon={faList} className="text-primary" />
                                        <span className="d-block">20</span>
                                        <span className="d-block text-primary f-14 fw-semibold">Total Task</span>
                                    </div>
                                    <div className="text-center border-right pe-2">
                                        <FontAwesomeIcon icon={faClock} className="text-secondary" />
                                        <span className="d-block">20</span>
                                        <span className="d-block text-secondary f-14 fw-semibold">Yet To Start</span>
                                    </div>
                                    <div className="text-center border-right pe-2">
                                        <FontAwesomeIcon icon={faStopwatch} className="text-info" />
                                        <span className="d-block">20</span>
                                        <span className="d-block text-info f-14 fw-semibold">In Progress</span>
                                    </div>
                                    <div className="text-center border-right pe-2">
                                        <FontAwesomeIcon icon={faPen} className="text-warning" />
                                        <span className="d-block">20</span>
                                        <span className="d-block text-warning f-14 fw-semibold">Review Pending</span>
                                    </div>
                                    <div className="text-center border-right pe-2">
                                        <FontAwesomeIcon icon={faCheckSquare} className="text-success" />
                                        <span className="d-block">20</span>
                                        <span className="d-block text-success f-14 fw-semibold">Approved</span>
                                    </div>
                                    <div className="text-center">
                                        <FontAwesomeIcon icon={faHeartbeat} className="text-danger" />
                                        <span className="d-block">20</span>
                                        <span className="d-block text-danger f-14 fw-semibold">Delayed Task</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mt-3 mb-3">
                    <div className="card-block">
                        <ul className="nav nav-pills" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" data-bs-toggle="pill" href="#candidate">Candidate</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="pill" href="#overview">Overview</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="pill" href="#task">Task</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="pill" href="#generate_loi">Generate LoI</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="pill" href="#query">Query</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="tab-content">
                    <div id="candidate" class="tab-pane active">
                        <div className="row">
                            <div className="col-lg-8">
                                <ContactDetails />
                                <PersonalDetails />
                                <Dependents />
                                <CurrentEmployment />
                                <AwardsAndAccolades />
                            </div>
                            <div className="col-lg-4">
                                <Skills />
                                <WorkExperience />
                                <EducationDetails />
                                <JobPosting />
                            </div>
                        </div>
                    </div>
                    <div id="overview" class="tab-pane fade">
                        <div className="row">
                            <div className="col-lg-3">
                                <AboutOverview />
                                <KeyContacts />
                            </div>
                            <div className="col-lg-6">
                                <ProfileReadiness />
                            </div>
                            <div className="col-lg-3">
                                <UploadDocument />
                            </div>
                            <div className="col-lg-6">
                                <TransactionTimeline />
                            </div>
                        </div>
                    </div>
                    <div id="task" class="tab-pane fade">
                        <div className="row">
                            <div className="col-lg-12">
                                <Task />
                            </div>
                        </div>
                    </div>
                    <div id="generate_loi" class="tab-pane fade">
                        <GenerateLoi />
                    </div>
                    <div id="query" class="tab-pane fade">
                        <Query />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;